import type { TournamentRoundsApi } from '@/v2/api/metadata/tournament-rounds'
import type { BackofficeContext } from '@/v2/framework/context/types'
import type { DialogConfig } from '@/v2/framework/dialog/types'
import { readApiData } from '@/v2/api/response'
import { createFeedConfigTab } from './tabs/feed-config'
import { createFeedMappingTab } from './tabs/feed-mapping'
import { createLiveTab } from './tabs/live'
import { createMainTab } from './tabs/main'
import { createPrematchTab } from './tabs/prematch'
import { createTranslationsTab } from './tabs/translations'

export function createEditDialog(options: {
  ctx: BackofficeContext
  roundsApi: TournamentRoundsApi
}): DialogConfig {
  const { ctx, roundsApi } = options

  return {
    id: 'edit-tournament-round',
    title: 'Edit tournament round',
    layout: {
      type: 'popover',
    },
    api: {
      initialValues: async (row) => {
        const response = await roundsApi.getSingle(row.id)
        const data = readApiData(response)
        return (data && typeof data === 'object' && !Array.isArray(data) ? data : {}) as Record<
          string,
          unknown
        >
      },
      submit: async () => {},
    },
    structure: {
      type: 'tabbed',
      savePerTab: true,
      tabs: [
        createMainTab(roundsApi),
        createPrematchTab(roundsApi),
        createLiveTab(roundsApi),
        createTranslationsTab({ ctx, roundsApi }),
        createFeedMappingTab(roundsApi),
        createFeedConfigTab(roundsApi),
      ],
    },
  }
}
